import { render, staticRenderFns } from "./LaporanAsetPage.vue?vue&type=template&id=356b2e1a"
import script from "./LaporanAsetPage.vue?vue&type=script&lang=js"
export * from "./LaporanAsetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports